// import api from '@/services/api.js'/
import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    productData: [],
    productsbycategory: { data: [], total: 1 },
    sizes: [],
    productsWithoutCategory: null,
  },
  mutations: {
    PRODUCT_DATA(state, payload) {
      state.productData = payload;
    },
    PRODUCTS_BY_CATEGORY(state, payload) {
      if (Array.isArray(payload)) {
        state.productsbycategory.data = payload;
        state.productsbycategory.total = payload.length;
      } else {
        state.productsbycategory.data = payload.data || [];
        state.productsbycategory.total =
          payload.total != null
            ? payload.total
            : state.productsbycategory.data.length;
      }
    },
    SET_SIZES(state, sizes) {
      state.sizes = sizes;
    },
    SET_PRODUCTS_WITHOUT_CATEGORY(state, payload) {
      state.productsWithoutCategory = payload;
    },
  },
  actions: {
    async getProductData({ commit }) {
      try {
        commit("setLoading", true, { root: true });
        const getTags = api.get("/tags", {
          params: {
            all: 1,
          },
        });
        const getComponents = api.get("/admin/components", {
          params: {
            all: 1,
          },
        });
        const getColors = api.get("/colors");
        const getCategories = api.get("/admin/categories", {
          params: {
            all: 1,
          },
        });
        const getReasons = api.get("/admin/reasons", {
          params: {
            all: 1,
          },
        });
        let productData = {};
        await Promise.all([
          getTags,
          getComponents,
          getColors,
          getCategories,
          getReasons,
        ]).then((responses) => {
          const tags = responses[0];
          const components = responses[1];
          const colors = responses[2];
          const categories = responses[3];
          const reasons = responses[4];
          productData = {
            tags: tags.data.data,
            components: components.data.data,
            colors: colors.data.data,
            categories: categories.data.data,
            reasons: reasons.data.data,
          };
          commit("PRODUCT_DATA", productData);
          commit("setLoading", false, { root: true });
        });
        return productData;
      } catch (error) {
        return error;
      }
    },
    async getProductsByCategory({ commit }, payload) {
      const category =
        typeof payload === "string" ? payload : payload?.category ?? payload;
      const page =
        typeof payload === "object" && payload?.page != null ? payload.page : 1;
      const perPage = 50;
      const categoryParams =
        category !== "all_products_without_category"
          ? { categories: [category] }
          : {};

      try {
        commit("setLoading", true, { root: true });
        const res = await api.get(`/admin/products`, {
          params: { page, per_page: perPage, ...categoryParams },
        });
        const data = res.data.data || [];
        const total = res.data.meta?.total ?? data.length;
        commit("PRODUCTS_BY_CATEGORY", { data, total });
        commit("setLoading", false, { root: true });
      } catch (error) {
        commit("PRODUCTS_BY_CATEGORY", { data: [], total: 0 });
        commit("setLoading", false, { root: true });
        return error;
      }
    },
    async getProductsByCategoryPag({ commit }, data) {
      try {
        commit("setLoading", true, { root: true });
        const categoryParams =
          data.category && data.category !== "all_products_without_category"
            ? { categories: [data.category] }
            : {};
        const res = await api.get(`/admin/products`, {
          params: {
            page: data.page,
            per_page: 50,
            ...categoryParams,
          },
        });
        commit("PRODUCTS_BY_CATEGORY", res.data);

        commit("setLoading", false, { root: true });
      } catch (error) {
        return error;
      }
    },
    async getProductsByCategoryWithFilters({ commit }, data) {
      const category = data.category;
      const filters = data.filters || {};
      const page = data.page != null ? data.page : 1;
      const perPage = 50;
      const categoryParams =
        category !== "all_products_without_category"
          ? { categories: [category] }
          : {};
      const params = { page, per_page: perPage, ...filters, ...categoryParams };

      try {
        commit("setLoading", true, { root: true });
        const res = await api.get(`/admin/products`, { params });
        const list = res.data.data || [];
        const total = res.data.meta?.total ?? list.length;
        commit("PRODUCTS_BY_CATEGORY", { data: list, total });
        commit("setLoading", false, { root: true });
      } catch (error) {
        commit("PRODUCTS_BY_CATEGORY", { data: [], total: 0 });
        commit("setLoading", false, { root: true });
        return error;
      }
    },
    async deleteProduct({ dispatch, state }, productData) {
      try {
        await api.delete(`/admin/products/${productData.product_slug}`);
        if (state.productsWithoutCategory) {
          dispatch("getProductsByCategory", "all_products_without_category");
        } else {
          dispatch("getProductsByCategory", productData.product_category);
        }
      } catch (error) {
        return error;
      }
    },
  },
  getters: {
    getAllCategories(state) {
      const categories = state.productData?.categories || [];
      const data = [
        {
          name: "Все товары без категории",
          value: "all_products_without_category",
        },
        ...categories,
      ];
      return data;
    },
    getCategoriesWithStaticOption(state) {
      // Проверяем, что productData и categories существуют
      if (!state.productData || !state.productData.categories) {
        return [
          {
            name: "Все товары без категорий",
            value: "all_products_without_category",
          },
        ];
      }
      const categories = JSON.parse(
        JSON.stringify(state.productData.categories)
      );
      categories.unshift({
        name: "Все товары без категорий",
        value: "all_products_without_category",
      });
      return categories;
    },
  },
};
